<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="form"
    size="small"
  >
    <el-row :gutter="15">
      <el-col :md="12">
        <el-form-item
          label="From"
          prop="reply_to"
          :rules="[{ type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }]"
        >
          <el-input
            v-model="form.reply_to"
            placeholder="Default [reply_to] of the current selected template will be used if empty"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item
          label="Sender Name"
          prop="sender_name"
        >
          <el-input
            v-model="form.sender_name"
            placeholder="Default [sender_name] of the current selected template will be used if empty"
            clearable
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :md="12">
        <el-form-item
          label="Subject"
          prop="subject"
        >
          <el-input
            v-model="form.subject"
            placeholder="Subject"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item
          label="Greeting"
          prop="greeting"
        >
          <el-input
            v-model="form.greeting"
            placeholder="Default [greeting] of the current selected template will be used if empty"
            clearable
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Message"
          prop="message"
        >
          <el-input
            v-model="form.message"
            placeholder="Email Body Message"
            type="textarea"
            :rows="8"
            clearable
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rules: {
        subject: [
          { required: true, message: 'Subject of email is required', trigger: 'blur' }
        ],
        message: [
          { required: true, message: 'Message of email is required', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) resolve(true)
          else resolve(false)
        })
      })
    }
  }
}
</script>

<style>

</style>
